import React from "react";

export const Spinner = (props) => (
  <div className="spinner" role={"status"}>
    <div className="cube1"></div>
    <div className="cube2"></div>
  </div>
);
